import style from "../../../assets/scss/sub/startGuide.module.scss";
import {StartGuideOptions} from "./StartGuideOptions";
import React from "react";
import {useTranslation} from "react-i18next";
import {useLanguage} from "../../../hooks/hooks";
import {useStartGuideFunctions} from "./hooks/useStartGuideFunctions";
import {GroupMemberItemType, GuideType} from "../../../types/startGuide";

export function OrganStartGuide() {
    const { t } = useTranslation("startGuide");
    const { isKorean} = useLanguage();
    const { getImageByLanguage } = useStartGuideFunctions();
    const type = GuideType.GROUP_MEMBERS;

    return(
        <div className={style.processOrganContainerWrapper}>
            {/* 01 코드 받기 */}
            <StartGuideOptions img={getImageByLanguage(type, isKorean, GroupMemberItemType.CODE)}
                               idx={1} title={t('groupMembers.step1.title')}
                               containerStyle="balanceBottom"
            >
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('groupMembers.step1.item1')}
                    </li>
                </ul>
            </StartGuideOptions>

            {/* 02 다운로드 */}
            <div className={style.blueBg}>
                <StartGuideOptions img={getImageByLanguage(type, isKorean, GroupMemberItemType.DOWNLOAD)}
                                   idx={2} title={t('groupMembers.step2.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('groupMembers.step2.item1')}
                        </li>
                        <li className={style.listItem}>
                            {t('groupMembers.step2.item2')}
                        </li>
                        <li className={style.listSubItem}>{t('groupMembers.step2.item3')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 03 로그인 */}
                <StartGuideOptions img={getImageByLanguage(type, isKorean, GroupMemberItemType.LOGIN)}
                                   idx={3} title={t('groupMembers.step3.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('groupMembers.step3.item1')}
                        </li>
                        <li className={style.listSubItem}>{t('groupMembers.step3.item2')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 04 검사진행 */}
                <StartGuideOptions img={getImageByLanguage(type, isKorean, GroupMemberItemType.PROCESSING)}
                                   idx={4} title={t('groupMembers.step4.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('groupMembers.step4.item1')}
                        </li>
                    </ul>
                </StartGuideOptions>
            </div>

            {/* 05 결과보기 */}
            <StartGuideOptions img={getImageByLanguage(type, isKorean, GroupMemberItemType.RESULT)}
                               idx={5} title={t('groupMembers.step5.title')}
                               containerStyle="balanceTop"
            >
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>{t('groupMembers.step5.item1')}</li>
                </ul>
            </StartGuideOptions>
        </div>
    )
}